import type { SxProps, Theme } from '@mui/material';

export const rootSx: SxProps<Theme> = (theme) => ({
  p: 3,
  '& em': {
    color: theme.palette.primary.main,
    fontStyle: 'normal',
  },

  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2, 4),
    fontSize: '1.1rem',
  },

  '& .GenerativeGuideContent-main': {
    '& .GenerativeGuideContent-title': {
      fontSize: '2rem',
      lineHeight: 1.9,
      letterSpacing: 0.6,
      marginBottom: 1,
    },
    '& .GenerativeGuideContent-subtitle': {
      fontSize: '1rem',
      lineHeight: 1.9,
      fontWeight: 400,
      color: '#666',
      marginBottom: 2,
    },
  },

  // 본문
  '& .GenerativeGuideContent-section': {
    '& .GenerativeGuideContent-imageBox': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      margin: theme.spacing(4, 0),
      '& img': {
        maxWidth: '100%',
      },
      '& aside': {
        fontSize: '0.8rem',
        color: '#888',
      },
    },

    '& .GenerativeGuideContent-title': {
      fontSize: '1.3rem',
      fontWeight: 800,
      marginTop: theme.spacing(3),
      marginBottom: 2,
    },

    '& .GenerativeGuideContent-subtitle': {
      fontSize: '1.2rem',
      fontWeight: 600,
      marginTop: theme.spacing(6),
      marginBottom: 2,
      color: '#333',
    },

    '& p': {
      margin: theme.spacing(2, 0),
      fontSize: '0.9rem',
      lineHeight: 1.9,
      letterSpacing: 0.3,
      color: '#333',
    },
  },
});
